import React, { Component } from 'react'
import { Topbar } from './topbar'
import mcbounce from '../imgs/mc_front.gif'

import bkt from '../imgs/bkt.png'
import aerospace from '../imgs/aerospace.png'
import portalware from '../imgs/portalwaretest.gif'
import uxfactor from '../imgs/uxfactor.png'
import focalpoint from '../imgs/focalpointtest.gif'
import filteredink from '../imgs/sunset.svg'
import canary from '../imgs/epigraphics_canary.gif'
import datapictorial from '../imgs/datapictorialplanets.gif'
import portalink from '../imgs/portalink_previewcropped.gif'
import link from '../imgs/l-ink-gif2.gif'
import frog from '../imgs/livinglinkfrog.gif'
import chartist from '../imgs/chartist.png'
import svgraffiti from '../imgs/svgraffiti.gif'
import surprise2refine from '../imgs/surprise2refine.png'

import './main.css'

export class Publications extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pubList: [
                {
                    "title": "Surprise2Refine: Axis-Centered Exploration-To-Refinement for Agent-Assisted Creative Scaffolding",
                    "authors": "Yuzhe You, Gromit Yeuk-Yin Chan, Shunan Guo, Anlan Zhang, Eunyee Koh, Jian Zhao, Tongyu Zhou",
                    "conf": "ACM Symposium on User Interface Software and Technology",
                    "confshort": "(UIST 2026 - to appear)",
                    "doi": "https://doi.org/10.1145/3830398.3830612",
                    "img": surprise2refine,
                    "pdf": process.env.PUBLIC_URL + '/pubs/you_surprise2refine_2026.pdf',
                    "bibtex": `@inproceedings{you2026surprise2refine,
author = {You, Yuzhe and Chan, Gromit Yeuk-Yin and Guo, Shunan and Zhang, Anlan and Koh, Eunyee and Zhao, Jian and Zhou, Tongyu},
title = {Surprise2Refine: Axis-Centered Exploration-To-Refinement for Agent-Assisted Creative Scaffolding},
year = {2026},
publisher = {Association for Computing Machinery},
address = {New York, NY, USA},
url = {https://doi.org/10.1145/3830398.3830612},
doi = {10.1145/3830398.3830612},
booktitle = {Proceedings of the 39th Annual ACM Symposium on User Interface Software and Technology},
series = {UIST '26}
}`
                },
                {
                    "title": "SVGraffiti: Remixing the Web with Vector Illustrations",
                    "authors": "Tongyu Zhou, Joshua Kong Yang, Eric Nai-Li Chen, Jeff Huang",
                    "conf": "ACM Conference on Designing Interactive Systems",
                    "confshort": "(DIS 2026)",
                    "doi": "https://doi.org/10.1145/3800645.3812830",
                    "img": svgraffiti,
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_svgraffiti_2026.pdf',
                    "bibtex": `@inproceedings{zhou2026svgraffiti,
author = {Zhou, Tongyu and Yang, Joshua Kong and Chen, Eric Nai-Li and Huang, Jeff},
title = {SVGraffiti: Remixing the Web with Vector Illustrations},
year = {2026},
publisher = {Association for Computing Machinery},
address = {New York, NY, USA},
url = {https://doi.org/10.1145/3800645.3812830},
doi = {10.1145/3800645.3812830},
booktitle = {Proceedings of the 2026 ACM Designing Interactive Systems Conference},
location = {Singapore, Singapore},
series = {DIS '26}
}`
                },
                {
                    "title": "ChArtist: Generating Pictorial Charts with Unified Spatial and Subject Control",
                    "authors": "Shishi Xiao, Tongyu Zhou, David Laidlaw, Gromit Yeuk-Yin Chan",
                    "conf": "IEEE/CVF Conference on Computer Vision and Pattern Recognition",
                    "confshort": "(CVPR 2026)",
                    "doi": "https://openaccess.thecvf.com/content/CVPR2026/html/Xiao_ChArtist_Generating_Pictorial_Charts_with_Unified_Spatial_and_Subject_Control_CVPR_2026_paper.html",
                    "img": chartist,
                    "pdf": process.env.PUBLIC_URL + '/pubs/xiao_chartist_2026.pdf',
                    "bibtex": `@inproceedings{xiao2026chartist,
    author    = {Xiao, Shishi and Zhou, Tongyu and Laidlaw, David H. and Chan, Gromit Yeuk-Yin},
    title     = {ChArtist: Generating Pictorial Charts with Unified Spatial and Subject Control},
    booktitle = {Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},
    month     = {June},
    year      = {2026},
    pages     = {29211-29221}
}`
                },
                {
                    "title": "Living Link: Binding Live Data with Design Canvases",
                    "authors": "Tongyu Zhou, Eunyee Koh",
                    "conf": "ACM CHI Conference on Human Factors in Computing Systems",
                    "confshort": "(CHI EA 2026)",
                    "doi": "https://doi.org/10.1145/3772363.3798503",
                    "img": frog,
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_livinglink_poster_2026.pdf',
                    "bibtex": `@inproceedings{zhou2026livinglink,
author = {Zhou, Tongyu and Koh, Eunyee},
title = {Living Link: Binding Live Data with Design Canvases},
year = {2026},
isbn = {9798400722813},
publisher = {Association for Computing Machinery},
address = {New York, NY, USA},
url = {https://doi.org/10.1145/3772363.3798503},
doi = {10.1145/3772363.3798503},
abstract = {Data-embedded infographics are traditionally static documents that present a snapshot of data in a visually interesting way, yet are vulnerable to data depreciation. Conversely, data dashboards support dynamic data, yet are monotonous in presentation and bound to the constraints of a website. Instead, we propose a tool that allows users to create a synthesis of the two in the form of what we call "living designs." Using this tool, users can bind any information found on public websites to design canvas elements. Given a specified recurring interval provided by the user, the system will pull the same linked information to update the visual properties of the design. These auto-updates persist in the exported SVG via a custom injected script that runs each time the image file is opened. We provide a preliminary demonstration of how this tool could be used in practice via a user scenario.},
booktitle = {Proceedings of the Extended Abstracts of the 2026 CHI Conference on Human Factors in Computing Systems},
articleno = {438},
numpages = {7},
keywords = {live data, personalization, creative design, visualization},
location = {
},
series = {CHI EA '26}
}`
                },
                {
                    "title": "L.ink: Procedural Ink Growth for Controllable Surprise",
                    "authors": "Eric Nai-Li Chen, Joshua Kong Yang, Jeff Huang, Tongyu Zhou",
                    "conf": "ACM Symposium on User Interface Software and Technology",
                    "confshort": "(UIST 2025)",
                    "doi": "https://doi.org/10.1145/3746059.3747702",
                    "img": link,
                    "pdf": process.env.PUBLIC_URL + '/pubs/chen_l_ink_2025.pdf',
                    "bibtex": `@inproceedings{chen2025link,
author = {Chen, Eric Nai-Li and Yang, Joshua Kong and Huang, Jeff and Zhou, Tongyu},
title = {L.ink: Procedural Ink Growth for Controllable Surprise},
year = {2025},
isbn = {9798400720376},
publisher = {Association for Computing Machinery},
address = {New York, NY, USA},
url = {https://doi.org/10.1145/3746059.3747702},
doi = {10.1145/3746059.3747702},
abstract = {Control, a common principle in interface design, helps artists achieve desired outcomes when using creativity support tools. However, surprise also plays a role in creative practice by facilitating introspection and adaptation. Consequently, creativity support tools face the challenge of balancing these two properties. We present L.ink, a digital illustration tool that empowers artists to draw with controllable yet unpredictable procedural growth styles powered by L-systems. Through a formative study of an early prototype of the system, we identify three types of surprise and adapt our design with a direct-manipulation editing interface with live visual feedback and a hand-drawn stamp tool to afford control and mitigate unwanted surprise. We further evaluate how controllable surprise impacts creative workflow and experience through a task-based study with 12 artists. Based on our observations, we extract guidelines for when and how to effectively incorporate unpredictability into creativity support tools.},
booktitle = {Proceedings of the 38th Annual ACM Symposium on User Interface Software and Technology},
articleno = {156},
numpages = {15},
keywords = {Creativity Support Tools, Vector Illustration, Procedural Art},
location = {
},
series = {UIST '25}
}`
                },
                {
                    "title": "PortalInk: 2.5D Visual Storytelling with SVG Parallax and Waypoint Transitions",
                    "authors": "Tongyu Zhou, Joshua Kong Yang, Vivian Hsinyueh Chan, Ji Won Chung, Jeff Huang",
                    "conf": "ACM Symposium on User Interface Software and Technology",
                    "confshort": "(UIST 2024)",
                    "doi": "https://doi.org/10.1145/3654777.3676376",
                    "img": portalink,
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_portalink_2024.pdf',
                    "bibtex": `@inproceedings{zhou2024portalink,
    author = {Zhou, Tongyu and Yang, Joshua Kong and Chan, Vivian Hsinyueh and Chung, Ji Won and Huang, Jeff},
    title = {PortalInk: 2.5D Visual Storytelling with SVG Parallax and Waypoint Transitions},
    year = {2024},
    isbn = {9798400706288},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3654777.3676376},
    doi = {10.1145/3654777.3676376},
    booktitle = {Proceedings of the 37th Annual ACM Symposium on User Interface Software and Technology},
    numpages = {16},
    location = {Pittsburgh, PA, USA},
    series = {UIST '24}
}`
                },
                {
                    "title": "Data Pictorial: Deconstructing Raster Images for Data-Aware Animated Vector Posters",
                    "authors": "Tongyu Zhou, Gromit Yeuk-Yin Chan, Shunan Guo, Jane Hoffswell, Chang Xiao, Victor Soares Bursztyn, Eunyee Koh",
                    "conf": "ACM Symposium on User Interface Software and Technology",
                    "confshort": "(UIST 2024 Adjunct)",
                    "doi": "https://doi.org/10.1145/3672539.3686353",
                    "img": datapictorial,
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_datapictorial.pdf',
                    "bibtex": `@inproceedings{zhou2024datapictorial,
    author = {Zhou, Tongyu and Chan, Gromit Yeuk-Yin and Guo, Shunan and Hoffswell, Jane and Xiao, Chang and Bursztyn, Victor Soares and Koh, Eunyee},
    title = {Data Pictorial: Deconstructing Raster Images for Data-Aware Animated Vector Posters},
    year = {2024},
    isbn = {9798400707186},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3672539.3686353},
    doi = {10.1145/3672539.3686353},
    booktitle = {Adjunct Proceedings of the 37th Annual ACM Symposium on User Interface Software and Technology},
    numpages = {3},
    location = {Pittsburgh, PA, USA},
    series = {UIST '24 Adjunct}
}`
                },
                {
                    "title": "Epigraphics: Message-Driven Infographics Authoring",
                    "authors": "Tongyu Zhou, Jeff Huang, Gromit Yeuk-Yin Chan",
                    "conf": "ACM CHI Conference on Human Factors in Computing Systems",
                    "confshort": "(CHI 2024)",
                    "doi": "https://doi.org/10.1145/3613904.3642172",
                    "img": canary,
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_epigraphics_2024.pdf',
                    "award1": <div className="award">🏅&nbsp;Best Paper Honorable Mention Award&nbsp;</div>,
                    "award2": <div className='highlight'>🎥&nbsp;Presented at <b>Adobe SUMMIT Sneaks 2024</b> as <a href="https://www.youtube.com/watch?feature=shared&v=XSMO9-7pcq8">#ProjectInfographIt</a></div>,
                    "bibtex": `@inproceedings{zhou2024epigraphics,
    author = {Zhou, Tongyu and Huang, Jeff and Chan, Gromit Yeuk-Yin},
    title = {Epigraphics: Message-Driven Infographics Authoring},
    year = {2024},
    isbn = {9798400703300},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3613904.3642172},
    doi = {10.1145/3613904.3642172},
    booktitle = {Proceedings of the CHI Conference on Human Factors in Computing Systems},
    articleno = {200},
    numpages = {18},
    location = {Honolulu, HI, USA},
    series = {CHI '24}
}`
                },
                {
                    "title": "filtered.ink: Creating Dynamic Illustrations with SVG Filters",
                    "authors": "Tongyu Zhou, Connie Liu, Joshua Kong Yang, Jeff Huang",
                    "conf": "ACM CHI Conference on Human Factors in Computing Systems",
                    "confshort": "(CHI 2023)",
                    "doi": "https://doi.org/10.1145/3544548.3581051",
                    "img": filteredink,
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_filteredink_2023.pdf',
                    "website": "https://filtered.ink/#/",
                    "bibtex": `@inproceedings{zhou2023filteredink,
    author = {Zhou, Tongyu and Liu, Connie and Yang, Joshua Kong and Huang, Jeff},
    title = {filtered.ink: Creating Dynamic Illustrations with SVG Filters},
    year = {2023},
    isbn = {9781450394215},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3544548.3581051},
    doi = {10.1145/3544548.3581051},
    booktitle = {Proceedings of the 2023 CHI Conference on Human Factors in Computing Systems},
    articleno = {129},
    numpages = {15},
    location = {Hamburg, Germany},
    series = {CHI '23}
}`
                },
                {
                    "title": "FocalPoint: Adaptive Direct Manipulation for Selecting Small 3D Virtual Objects",
                    "authors": "Jiaju Ma, Jing Qian, Tongyu Zhou, and Jeff Huang",
                    "conf": "ACM Conference on Interactive, Mobile, Wearable and Ubiquitous Technologies",
                    "confshort": "(IMWUT 2023)",
                    "doi": "https://doi.org/10.1145/3580856",
                    "img": focalpoint,
                    "pdf": process.env.PUBLIC_URL + '/pubs/ma_focalpoint_2023.pdf',
                    "bibtex": `@article{ma2023focalpoint,
    author = {Ma, Jiaju and Qian, Jing and Zhou, Tongyu and Huang, Jeff},
    title = {FocalPoint: Adaptive Direct Manipulation for Selecting Small 3D Virtual Objects},
    year = {2023},
    issue_date = {March 2023},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    volume = {7},
    number = {1},
    url = {https://doi.org/10.1145/3580856},
    doi = {10.1145/3580856},
    journal = {Proc. ACM Interact. Mob. Wearable Ubiquitous Technol.},
    month = {mar},
    articleno = {22},
    numpages = {26},
}`
                },
                {  
                    "title": "The UX Factor: Using Comparative Peer Review to Evaluate Designs through User Preferences",
                    "authors": "Sarah Bawabe*, Laura Wilson*, Tongyu Zhou*, Ezra Marks, and Jeff Huang",
                    "conf": "ACM Conference on Computer Supported Cooperative Work & Social Computing",
                    "confshort": "(CSCW 2021)",
                    "doi": "https://doi.org/10.1145/3479863",
                    "img": uxfactor,
                    "pdf": process.env.PUBLIC_URL + '/pubs/bawabe_uxfactor_2021.pdf',
                    "award1": <div className="award">🏅&nbsp;Best Paper Honorable Mention Award&nbsp;</div>,
                    "award2": <div className="award">💥&nbsp;Impact Recognition Award&nbsp;</div>,
                    "website": "https://uxfactor.cs.brown.edu/",
                    "bibtex": `@article{bawabe2021uxfactor,
    author = {Bawabe, Sarah and Wilson, Laura and Zhou, Tongyu and Marks, Ezra and Huang, Jeff},
    title = {The UX Factor: Using Comparative Peer Review to Evaluate Designs through User Preferences},
    year = {2021},
    issue_date = {October 2021},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    volume = {5},
    number = {CSCW2},
    url = {https://doi.org/10.1145/3479863},
    doi = {10.1145/3479863},
    journal = {Proc. ACM Hum.-Comput. Interact.},
    month = {oct},
    articleno = {476},
    numpages = {23},
}
`
                },
                {  
                    "title": "Portalware: Exploring Free-Hand AR Drawing with a Dual-Display Smartphone-Wearable Paradigm",
                    "authors": "Jing Qian*, Tongyu Zhou*, Meredith Young-Ng*, Jiaju Ma, Angel Cheung, Xiangyu Li, Ian Gonsher, and Jeff Huang",
                    "conf": "ACM Conference on Designing Interactive Systems",
                    "confshort": "(DIS 2021)",
                    "doi": "https://dl.acm.org/doi/10.1145/3461778.3462098",
                    "img": portalware,
                    "pdf": process.env.PUBLIC_URL + '/pubs/qian_portalware_2021.pdf',
                    "video": "https://www.youtube.com/watch?v=UaHIWJOA-PU",
                    "bibtex": `@inproceedings{qian2021portalware,
    author = {Qian, Jing and Zhou, Tongyu and Young-Ng, Meredith and Ma, Jiaju and Cheung, Angel and Li, Xiangyu and Gonsher, Ian and Huang, Jeff},
    title = {Portalware: Exploring Free-Hand AR Drawing with a Dual-Display Smartphone-Wearable Paradigm},
    year = {2021},
    isbn = {9781450384766},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3461778.3462098},
    doi = {10.1145/3461778.3462098},
    booktitle = {Proceedings of the 2021 ACM Designing Interactive Systems Conference},
    pages = {205–219},
    numpages = {15},
    location = {Virtual Event, USA},
    series = {DIS '21}
}`
                },
                {  
                    "title": "Combining Genetic Algorithms and Machine Learning for Exploring the Navigation Satellite Constellation Design Tradespace",
                    "authors": "Jacob Chang, Rachel Duquette, Katherine Thai, Tongyu Zhou, Minh Pham, Victor Lin, and Karen Wood",
                    "conf": "International Technical Meeting of the Satellite Division of the Institute of Navigation",
                    "confshort": "(ION GNSS+ 2020)",
                    "doi": "https://www.ion.org/publications/abstract.cfm?articleID=17616",
                    "img": aerospace,
                    "bibtex": `@inproceedings{chang2020combining,
    title={Combining genetic algorithms and machine learning for exploring the navigation satellite constellation design tradespace},
    author={Chang, Jacob and Duquette, Rachel and Thai, Katherine and Zhou, Tongyu and Pham, Minh and Lin, Victor and Wood, Karen},
    booktitle={Proceedings of the 33rd International Technical Meeting of the Satellite Division of The Institute of Navigation (ION GNSS+ 2020)},
    pages={1209--1228},
    year={2020}
}`
                },
                {  
                    "title": "Assessing Post-hoc Explainability of the BKT Algorithm",
                    "authors": "Tongyu Zhou*, Haoyu Sheng*, and Iris Howley",
                    "conf": "AAAI/ACM Conference on AI, Ethics, and Society",
                    "confshort": "(AIES 2020)",
                    "doi": "https://dl.acm.org/doi/10.1145/3375627.3375856",
                    "pdf": process.env.PUBLIC_URL + '/pubs/zhou_assessing_2020.pdf',
                    "img": bkt,
                    "bibtex": `@inproceedings{zhou2020assessing,
    author = {Zhou, Tongyu and Sheng, Haoyu and Howley, Iris},
    title = {Assessing Post-hoc Explainability of the BKT Algorithm},
    year = {2020},
    isbn = {9781450371100},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3375627.3375856},
    doi = {10.1145/3375627.3375856},
    booktitle = {Proceedings of the AAAI/ACM Conference on AI, Ethics, and Society},
    pages = {407–413},
    numpages = {7},
    location = {New York, NY, USA},
    series = {AIES '20}
}`
                },
            ],
            showBibtex: {}
        }
    }

    displayLink(url, type) {
        if (url !== undefined) {
            return(
                <a className="pad-10-right" href={url}>[{type}]</a>
            )
        }
    }

    filterMe(authorList) {
        var myName = "Tongyu Zhou"
        let arr = authorList.split(myName)
        return <span>{arr[0]}<i className='highlight name-highlight'>{myName}</i>{arr[1]}</span>
    }

    renderThumbnailImg(pub) {
        if (pub.img.endsWith(".svg")) {
            return (
                <object className="pub-icon" aria-label={"Icon for the paper " + pub.title} data={pub.img} type="image/svg+xml" width={165}></object>
            )
        }
        else {
            return (
                <img alt={"Icon for the paper " + pub.title} className="pub-icon" src={pub.img} width={165}></img>
            )
        }
    }

    toggleBibtex(index) {
        this.setState(prevState => ({
            showBibtex: {
                ...prevState.showBibtex,
                [index]: !prevState.showBibtex[index]  // Toggle the specific bibtex visibility
            }
        }));
    }

    render() {
        return(
            <div>
                <div className="top">
                    <Topbar/>
                    <div className="about-wrapper">
                        <div className="flex-column pub-wrapper">
                            {/* <div className="pub-header">
                            Select publications. For a full list, please refer to my CV. * denotes equal contribution
                            </div> */}
                            {this.state.pubList.map((pub, index) => 
                                <div key={"pub-"+index} className="flex-row pub">
                                    <div>
                                        {this.renderThumbnailImg(pub)}
                                    </div>
                                    <div className="pub-text">
                                        <div className="pub-title">
                                            {pub.title}
                                        </div>
                                        <div>
                                            {this.filterMe(pub.authors)}
                                        </div>
                                        <div>
                                           <span className="italics-text">{pub.conf}</span> <span className="bold-text"> {pub.confshort}</span>
                                        </div>
                                        {pub.award1}{pub.award2}
                                        <div style={{paddingBottom: "5px"}}>
                                            {this.displayLink(pub.website, "💻 website")}
                                            {this.displayLink(pub.pdf, "📑 pdf")}
                                            {this.displayLink(pub.video, "🎬 video")}
                                            {this.displayLink(pub.doi, "🔗 doi")}
                                            <span onClick={() => this.toggleBibtex(index)}
                                                style={{ cursor: 'pointer'}}
                                            >
                                                <a className="pad-10-right">
                                                    {this.state.showBibtex[index] ? '[📚 bibtex ↑]' : '[📚 bibtex ↓]'}
                                                </a>
                                            </span>
                                        </div>
                                        {this.state.showBibtex[index] && 
                                            <div className="bibtex-citation">
                                                <pre>{pub.bibtex}</pre>  {/* Assuming pub.bibtex contains the BibTeX citation */}
                                            </div>
                                        }
                                    </div>
                                </div>
                            )
                            }
                            <div style={{fontSize: "0.8em", color: "rgb(97, 93, 93)"}}>
                                Made it to the bottom? I also used to <a href="https://eutopi.portfoliobox.net/">doodle</a> a lot 🎨
                                <img src={mcbounce} alt="Animated GIF"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-row flex-center footer">
                    <footer className="bottom">made while boppin' to city pop 🌃🎶 by Tongyu Zhou</footer>
                </div>
            </div>
        )
    }
}